import { combineReducers } from 'redux'
import request from 'utils/request'
import { stringsActions } from 'store/strings'
import { LOCAL_STORAGE_KEYS } from 'utils/constants'
import { formatApplangaKey } from 'utils/localization'

//
// Actions
//

const SET_LOCALES = 'SET_LOCALES'
const SET_LOCALE = 'SET_LOCALE'

//
// Action creators
//

export const setLocales = locales => ({
    type: SET_LOCALES,
    locales
  })
export const setLocale = locale => ({
    type: SET_LOCALE,
    locale
  })

//
// Util functions
//

export const selectLanguage = languageItem => dispatch => {
  const applangaId = formatApplangaKey(languageItem.applanga)
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.localization,
    JSON.stringify({
      selectedLanguage: languageItem.key,
      applangaId
    })
  )
  dispatch(setLocale(languageItem.key))
  dispatch(stringsActions.onFetchApplangaStrings(applangaId, languageItem.key))
}

const getLocaleOptions = locales => {
  const list = locales
    ? locales
        .map(option => {
          const { applanga, id, locale, name } = option
          return {
            key: id,
            text: name,
            value: id,
            id,
            locale,
            applanga
          }
        })
        .sort((a, b) => a.text.localeCompare(b.text))
    : []
  return list
}

//
// Fetch functions
//

export const fetchLocales = () => dispatch => {
    const success = payload => {
      dispatch({
        type: SET_LOCALES,
        locales: getLocaleOptions(payload.languages)
      })
    }
    return dispatch(
      request({
        method: 'GET',
        url: '/control/locales',
        success
      })
    )
  }

//
// Reducers
//

const localesList = (state, action = {}) => {
  const currentState = state === undefined ? [] : state

  switch (action.type) {
    case SET_LOCALES:
      return action.locales
    default:
      return currentState
  }
}
const selectedLocale = (state, action = {}) => {
  const currentState = state === undefined ? 'en_US' : state

  switch (action.type) {
    case SET_LOCALE:
      return action.locale
    default:
      return currentState
  }
}

export default combineReducers({
  localesList,
  selectedLocale
})
